/**
 * Qual cartão salvo vai na compra.
 *
 * O campo `creditCard.id` nasce `0` (cartão novo). Ao trocar para "usar cartão
 * salvo" o seletor MOSTRA o primeiro cartão, mas o valor do formulário seguia
 * `0` até o comprador mexer no seletor — e com um cartão só não há o que mexer.
 * O checkout mandava `id: 0`, o pay entendia "cartão novo sem dados" e a compra
 * falhava.
 *
 * Regra: id válido da lista fica; qualquer outra coisa vira o primeiro cartão.
 */
export const resolveSavedCardId = (
	currentId: number | string | null | undefined,
	savedCards: { id: number }[] | null | undefined
): number | undefined => {
	if (!savedCards || savedCards.length === 0) return undefined;

	const current = Number(currentId);
	if (current && savedCards.some((card) => card.id === current)) {
		return current;
	}

	return savedCards[0].id;
};
